import Modal from "./Modal";

const ConfirmDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Xác nhận xóa",
  message = "Bạn có chắc chắn muốn xóa dữ liệu này không?",
  loading = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      maxWidth="420px"
      cancelButtonText="Hủy"
      showCancelButton
      primaryButtonText={loading ? "Đang xóa..." : "Xóa"}
      primaryButtonVariant="danger"
      primaryButtonOnClick={onConfirm}
    >
      <div className="px-6 py-4">
        <p className="text-gray-700">{message}</p>
        <p className="text-sm text-gray-500 mt-2">
          Thao tác này không thể hoàn tác.
        </p>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
